export { default } from "ember-stereo/helpers/rewind-sound";
